export default {
    state: {
        isShowMultiEdit: false,

        multiEditAssetType: null,

        multiEditAddFilter: [],
        multiEditRemoveFilter: [],

        multiEditReplaceTag: false,
        multiEditAddTag: [],
        multiEditRemoveTag: [],

        multiEditReplaceAdditionalTag: false,
        multiEditAdditionalTag: '',
    },
    getters: {
        IS_SHOW_MULTI_EDIT: state => {return state.isShowMultiEdit},
        MULTI_EDIT_ASSET_TYPE: state => {return state.multiEditAssetType},

        MULTI_EDIT_ADD_FILTER: state => {return state.multiEditAddFilter},
        MULTI_EDIT_REMOVE_FILTER: state => {return state.multiEditRemoveFilter},

        MULTI_EDIT_REPLACE_TAG: state => {return state.multiEditReplaceTag},
        MULTI_EDIT_ADD_TAG: state => {return state.multiEditAddTag},
        MULTI_EDIT_REMOVE_TAG: state => {return state.multiEditRemoveTag},

        MULTI_EDIT_REPLACE_ADDITIONAL_TAG: state => {return state.multiEditReplaceAdditionalTag},
        MULTI_EDIT_ADDITIONAL_TAG: state => {return state.multiEditAdditionalTag},
    },
    mutations: {
        IS_SHOW_MULTI_EDIT: (state, payload) => {state.isShowMultiEdit = payload},
        MULTI_EDIT_ASSET_TYPE: (state, payload) => {state.multiEditAssetType = payload},

        MULTI_EDIT_ADD_FILTER: (state, payload) => {state.multiEditAddFilter = payload},
        MULTI_EDIT_REMOVE_FILTER: (state, payload) => {state.multiEditRemoveFilter = payload},

        MULTI_EDIT_REPLACE_TAG: (state, payload) => {state.multiEditReplaceTag = payload},
        MULTI_EDIT_ADD_TAG: (state, payload) => {state.multiEditAddTag = payload},
        MULTI_EDIT_REMOVE_TAG: (state, payload) => {state.multiEditRemoveTag = payload},

        MULTI_EDIT_REPLACE_ADDITIONAL_TAG: (state, payload) => {state.multiEditReplaceAdditionalTag = payload},
        MULTI_EDIT_ADDITIONAL_TAG: (state, payload) => {state.multiEditAdditionalTag = payload},
    },
    actions: {
        MULTI_EDITE_CLEAR: async function(context) {
            context.commit('MULTI_EDIT_ADD_FILTER', []);
            context.commit('MULTI_EDIT_REMOVE_FILTER', []);

            context.commit('MULTI_EDIT_REPLACE_TAG', false);
            context.commit('MULTI_EDIT_ADD_TAG', []);
            context.commit('MULTI_EDIT_REMOVE_TAG', []);

            context.commit('MULTI_EDIT_REPLACE_ADDITIONAL_TAG', false);
            context.commit('MULTI_EDIT_ADDITIONAL_TAG', '');
        }
    }
}